export default __webpack_public_path__ + "static/media/cert-bg.1ee5f227.webp";